export const languages = [
  { code: 'de', name: 'Deutsch', path: '/', locale: 'de_DE', dateLocale: 'de-DE' },
  { code: 'en', name: 'English', path: '/en', locale: 'en_US', dateLocale: 'en-GB' },
  { code: 'bg', name: 'Български', path: '/bg', locale: 'bg_BG', dateLocale: 'bg-BG' },
  { code: 'tr', name: 'Türkçe', path: '/tr', locale: 'tr_TR', dateLocale: 'tr-TR' },
]

export const defaultLanguage = 'de'
export const languageCodes = languages.map((lang) => lang.code)
export const getLanguage = (code) => languages.find((lang) => lang.code === code) ?? languages[0]

// The root path ("/") for the default language; every other language lives
// under its own prefix ("/en", "/bg", "/tr"), so each is a separate,
// indexable URL rather than a client-side toggle.
export const pathFor = (code) => getLanguage(code).path
